(() => {
  const initProduct = (root) => {
    if (!root || root.dataset.productV2Ready === 'true') return;
    root.dataset.productV2Ready = 'true';

    const compare = root.querySelector('[data-y-compare-price]');
    const save = root.querySelector('[data-y-save-badge]');
    const stickyPrice = root.querySelector('[data-y-sticky-price]');
    const stickyCompare = root.querySelector('[data-y-sticky-compare]');
    const sticky = root.querySelector('[data-y-sticky-buy]');
    const form = root.querySelector('[data-y-product-form]');

    const updateVariantExtras = (pill) => {
      if (!pill) return;
      const price = pill.dataset.price || '';
      const compareText = pill.dataset.comparePrice || '';
      const savePercent = parseInt(pill.dataset.savePercent || '0', 10) || 0;

      if (stickyPrice && price) stickyPrice.textContent = price;
      if (compare) {
        compare.textContent = compareText;
        compare.classList.toggle('is-hidden', !compareText);
      }
      if (stickyCompare) {
        stickyCompare.textContent = compareText;
        stickyCompare.classList.toggle('is-hidden', !compareText);
      }
      if (save) {
        save.textContent = savePercent > 0 ? 'SAVE ' + savePercent + '%' : '';
        save.classList.toggle('is-hidden', savePercent <= 0);
      }
    };

    root.querySelectorAll('[data-y-variant-pill]').forEach((pill) => {
      pill.addEventListener('click', () => updateVariantExtras(pill));
    });
    updateVariantExtras(root.querySelector('[data-y-variant-pill].is-active'));

    const countdown = root.querySelector('[data-y-offer-countdown]');
    if (countdown && countdown.dataset.countdownReady !== 'true') {
      countdown.dataset.countdownReady = 'true';
      const endTime = new Date(countdown.dataset.end || '').getTime();
      const label = countdown.querySelector('[data-countdown-label]');
      const daysEl = countdown.querySelector('[data-countdown-days]');
      const hoursEl = countdown.querySelector('[data-countdown-hours]');
      const minutesEl = countdown.querySelector('[data-countdown-minutes]');
      const secondsEl = countdown.querySelector('[data-countdown-seconds]');
      const expiredText = countdown.dataset.expiredText || 'Offer ended';

      const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
      let timer;

      const renderCountdown = () => {
        if (!Number.isFinite(endTime)) {
          countdown.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }

        const diff = endTime - Date.now();
        if (diff <= 0) {
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          if (label) label.textContent = expiredText;
          countdown.classList.add('is-expired');
          if (timer) clearInterval(timer);
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      };

      renderCountdown();
      timer = setInterval(renderCountdown, 1000);
    }

    if (sticky) {
      const toggleSticky = () => {
        const formRect = form ? form.getBoundingClientRect() : null;
        const shouldShow = window.scrollY > 420 && (!formRect || formRect.bottom < 40);
        sticky.classList.toggle('is-visible', shouldShow);
      };
      window.addEventListener('scroll', toggleSticky, { passive: true });
      toggleSticky();
    }
  };

  const initReviews = (root) => {
    if (!root || root.dataset.reviewSliderReady === 'true') return;
    root.dataset.reviewSliderReady = 'true';
    const track = root.querySelector('[data-review-track]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.y-review-card');
      return card ? card.getBoundingClientRect().width + 20 : Math.min(390, window.innerWidth * .85);
    };
    root.querySelector('[data-review-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-review-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('.y-product-v2').forEach(initProduct);
    scope.querySelectorAll?.('[data-y-review-slider]').forEach(initReviews);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();